import React from 'react';
import { useController, useFormContext, useWatch } from 'react-hook-form';
import ErrorMessage from '../ErrorMessage';
import Input, { InputProps } from '../Input';
import TopFieldContent from '../TopFieldContent';
import CharactersCount from '../CharactersCount/CharactersCount';
import useTranslation from '../../../../../../Hooks/useTranslation';
import useFormName from '../../../../../../Hooks/useFormName';
import InputWrapper from '../InputWrapper/InputWrapper';

interface InputFieldProps extends InputProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	placeholder?: string;
	charactersLimit?: number;
	isWrapped?: boolean;
}

const InputField = ({
	name,
	label,
	isRequired,
	className,
	placeholder,
	charactersLimit,
	isWrapped,
	...inputProps
}: InputFieldProps) => {
	const { t } = useTranslation();
	const { fieldName } = useFormName({ name });

	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: '',
	});

	const component = (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<Input
				hasError={Boolean(error?.message)}
				{...inputProps}
				{...field}
				placeholder={t(placeholder)}
			/>
			{error?.message && <ErrorMessage tx={error.message} />}
			{charactersLimit && (
				<CharactersCount limit={charactersLimit} value={field.value} />
			)}
		</div>
	);

	if (isWrapped) {
		return <InputWrapper>{component}</InputWrapper>;
	}

	return component;
};

export default InputField;
